import { render, staticRenderFns } from "./checkbox-round.html?vue&type=template&id=055a9c57&scoped=true&"
import script from "./checkbox-round.js?vue&type=script&lang=js&"
export * from "./checkbox-round.js?vue&type=script&lang=js&"
import style0 from "./checkbox-round.scss?vue&type=style&index=0&id=055a9c57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a9c57",
  null
  
)

export default component.exports